// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e069b051","459":"46e61cce"}[chunkId] + ".chunk.js";
};